import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/freelancer/projects/FreelancerMarketProjectsClient.tsx");
